import { gql } from '@apollo/client';
import { List } from '@apollo/orbit';
import classnames from 'classnames';
import { MomentInput } from 'moment';
import React from 'react';

import { GraphQLTypes } from 'src/lib/graphqlTypes';
import { NormalizedSchemaCoordinateFieldMetricsField } from 'src/lib/metrics';

import { FieldsListItem } from '../insightsListItem/FieldsListItem';

export const CoordinateInsightsListItemFragment = gql`
  fragment CoordinateInsightsListItemFragment on CoordinateInsightsListItem {
    namedType
    namedAttribute
    referencingOperationCount
    referencingOperationCountPerMin
    executionCount
    estimatedExecutionCount
  }
`;

type SchemaCoordinateListBodyProps = {
  coordinates: Array<GraphQLTypes.CoordinateInsightsListItemFragment>;
  timeFrom: MomentInput;
  timeTo: MomentInput;
  selectedCoordinate?: string;
  statsSortKey: NormalizedSchemaCoordinateFieldMetricsField;
  loading: boolean;
};

export const SchemaCoordinateListBody = ({
  coordinates,
  selectedCoordinate,
  statsSortKey,
  loading,
}: SchemaCoordinateListBodyProps) => {
  if (coordinates.length === 0) {
    return null;
  }

  return (
    <List
      isInteractive
      className={classnames('pt-2', {
        'motion-safe:animate-pulse-faded': loading,
      })}
    >
      {coordinates.map((coordinate) => {
        const name = `${coordinate.namedType || 'undefined'}.${
          coordinate.namedAttribute || 'undefined'
        }`;

        return (
          <FieldsListItem
            key={name}
            loading={loading}
            name={name}
            requestsCount={coordinate.referencingOperationCount}
            requestRate={coordinate.referencingOperationCountPerMin}
            executions={coordinate.estimatedExecutionCount}
            statsSortKey={statsSortKey}
            isSelected={name === selectedCoordinate}
          />
        );
      })}
    </List>
  );
};
